import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, Col, CardBody } from 'reactstrap';
import FormBuilder from '../Components/FormBuilder';


function ModalInci(props) {
	// console.log('propsModal', props);
	const [openModal, setopenModal] = useState(false);

	function toggle() {
		setopenModal(!openModal);
	}

	return (
		<React.Fragment>
			<hr></hr>
			<Col style={{ textAlignLast: 'center' }}>
				<Button
					color='primary'
					onClick={toggle}
					hidden={props.Model['incidenttype'].value === 'Not Incident' ? false : true}
				>
					<i className='fas fa-plus-circle mr-2' />
					<b>Create Incident</b>
				</Button>
			</Col>
			<Modal
				isOpen={openModal}
			>
				<ModalBody>
					<CardBody style={{ textAlignLast: 'center' }}>
						<i
							style={{ fontSize: '7em', color: 'orange' }}
							className='fas fa-exclamation-circle'></i>
					</CardBody>
					<FormBuilder dataForm={props.dataForm} Model={props.Model} Catalog={props.Catalog} onChange={props.onChange} />
				</ModalBody>
				<ModalFooter style={{ justifyContent: 'center' }}>
					<Button
						color="primary"
						onClick={() => { props.CreateIncident(); setopenModal(false); }}
					>
						<i className='fas fa-save mr-2' />Save</Button>{' '}
					<Button
						color="danger"
						onClick={() => { setopenModal(false); props.onCancel(); }}>
						<i className='fas fa-window-close mr-2' />Cancel</Button>
				</ModalFooter>
			</Modal>
		</React.Fragment>
	);
};


ModalInci.defaultProps = {
	onCancel: () => { },
};

export default ModalInci;